import { useEffect, useState } from 'react';
import { QrCodePix } from 'qrcode-pix';

const PixQRCode = () => {
  const [qrCodeBase64, setQrCodeBase64] = useState('');

  useEffect(() => {
    const generatePixQRCode = async () => {
      const pix = QrCodePix({
        version: '01',
        key: '04331698009',
        name: 'MILENA KALINOSKI DIAS',
        city: 'ERECHIM',
        transactionId: 'TX' + Date.now(),
        message: 'Presente de Aniversário',
      });

      const qrCodeImage = await pix.base64();
      setQrCodeBase64(qrCodeImage);
    };

    generatePixQRCode();
  }, []);

  return (
    <div style={{ marginTop: '30px' }}>
      {qrCodeBase64 && (
        <img
          src={qrCodeBase64}
          alt="QR Code PIX"
          style={{ width: '300px', border: '2px solid #ccc', borderRadius: '12px' }}
        />
      )}
    </div>
  );
};

export default PixQRCode;